import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/policy',
  component: Layout,
  redirect: '/policy/index',
  name: 'Policy',
  meta: {
    title: '政策管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'PolicyIndex',
      component: () => import('@/views/policy/index.vue'),
      meta: {
        title: '政策管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/policy"
      },
    }
  ],
}

export default routes
